var _rect, _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStopSpeedtram = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 32 32"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 3,
  height: 8,
  x: 14.5,
  y: 22,
  fill: "#333",
  rx: 1.5
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 13,
  r: 11,
  fill: "#007E79"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#stop-speedtram_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#007E79",
  d: "M10 5h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H10a2 2 0 0 1-2-2V7c0-1.104.896-2 2-2"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m19.924 14.96-.832-5.806a1.21 1.21 0 0 0-.664-.94c-.763-.36-1.553-.497-2.01-.552v-.704h1.47a.395.395 0 0 0 0-.789h-3.754a.395.395 0 0 0 0 .79h1.473v.703c-.459.055-1.249.191-2.012.553-.36.17-.607.527-.662.94l-.832 5.804c-.062.436-.02.882.12 1.298.082.247.236.744.33.988.131.343.43.584.77.672.619.16 1.54.3 2.69.3s2.073-.14 2.69-.3c.341-.088.64-.33.772-.672.093-.243.247-.74.33-.988.139-.416.183-.862.12-1.298m-.748.813-.21.645c-.053.164-.139.205-.267.244-.292.088-1.526.298-2.687.306-1.163-.008-2.394-.218-2.686-.306-.128-.04-.213-.08-.267-.244l-.21-.645c-.047-.146.073-.25.236-.205.503.136 1.063.25 1.528.342a.47.47 0 0 1 .334.24c.072.149.217.25.371.26a11 11 0 0 0 1.386 0c.155-.01.3-.112.372-.26a.47.47 0 0 1 .333-.24 23 23 0 0 0 1.53-.342c.163-.044.284.059.236.205zm-.32-1.128a9.8 9.8 0 0 1-2.844.447 9.8 9.8 0 0 1-2.842-.447.32.32 0 0 1-.219-.35l.588-4.105a.32.32 0 0 1 .252-.267c.577-.12 1.364-.231 2.221-.231s1.646.11 2.223.23a.32.32 0 0 1 .252.268l.588 4.105a.32.32 0 0 1-.219.35m-.572 3.962a10 10 0 0 1-.91.136s.606.72.764.91c.205.245.372.323.606.323.266 0 .503-.196.223-.546a96 96 0 0 0-.682-.823m-4.543 0c.279.057.591.102.91.136l-.764.91c-.205.245-.371.323-.606.323-.266 0-.503-.196-.223-.546.138-.171.683-.823.683-.823"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "stop-speedtram_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M8 5h16v16H8z"
})))));
export { SvgStopSpeedtram as ReactComponent };